/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFolderNotEditable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h8.618l2 4H22v5h-2V8h-8.618l-2-4H4v16h7v2H2zm16.293 11.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-1.5 1.5-1.414-1.414.793-.793L19 15.414l-.793.793-1.414-1.414zM14.086 17.5l-1.293-1.293 1.414-1.414 7 7-1.414 1.414-1.293-1.293L17.414 23H13v-4.414zm1.414 1.414-.5.5V21h1.586l.5-.5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFolderNotEditable as FolderNotEditable };
